<section class="py-16">
  <app-content-container>
    <div class="text-center">
      <h1 class="text-3xl md:text-4xl font-bold pb-4">
        Sobre a <span class="text-primary">Code Dimension</span>
      </h1>
      <p class="text-xl max-w-3xl mx-auto">
        Conheça nossa história, missão e valores
      </p>
    </div>
  </app-content-container>
</section>

<section class="page-section pt-16">
  <app-content-container>
    <div class="max-w-4xl mx-auto">
      <h2 class="text-2xl md:text-3xl font-bold pb-6 text-center">
        Nossa missão
      </h2>
      <div class="bg-base-100 p-8 rounded-lg shadow-lg">
        <p class="text-lg pb-4">
          A Code Dimension foi criada por <strong>Henrique Custódia</strong> em
          <strong>2023</strong>
          com um propósito claro: compartilhar conhecimento de qualidade com a
          comunidade Angular.
        </p>
        <p class="text-lg pb-4">
          Henrique sempre sentiu falta desse tipo de conteúdo especializado e
          didático voltado para o ecossistema Angular no Brasil. Vendo essa
          lacuna no mercado, ele decidiu criar uma plataforma que oferecesse
          cursos práticos, atualizados e focados nas reais necessidades dos
          desenvolvedores.
        </p>
        <p class="text-lg">
          Nosso compromisso é transformar a maneira como o conhecimento técnico
          é transmitido, tornando-o acessível, relevante e inspirador para todos
          que desejam crescer como desenvolvedores Angular.
        </p>
      </div>
    </div>
  </app-content-container>
</section>

<section class="page-section pt-16">
  <app-content-container>
    <div class="max-w-4xl mx-auto">
      <h2 class="text-2xl md:text-3xl font-bold pb-6 text-center">
        Nossos valores
      </h2>
      <div class="bg-base-100 p-8 rounded-lg shadow-lg">
        <p class="text-lg pb-4">
          Na Code Dimension, colocamos nossos estudantes em primeiro lugar.
          Acreditamos que investir na educação de qualidade é investir no futuro
          da tecnologia brasileira.
        </p>
        <p class="text-lg pb-4">
          Mantemos um compromisso inabalável com a honestidade em todas as
          nossas relações, seja com nossos clientes ou com a comunidade.
          Valorizamos a transparência e a autenticidade em tudo o que fazemos.
        </p>
        <p class="text-lg">
          Nosso objetivo é contribuir significativamente para o crescimento e
          aprimoramento da comunidade Angular no Brasil, criando profissionais
          mais capacitados e confiantes em suas habilidades técnicas.
        </p>
      </div>
    </div>
  </app-content-container>
</section>
